import React, { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import ReactApexChart from "react-apexcharts";
import { noData } from '../../../utils/data';
import timeSheetsService from '../../../services/time.sheets.service';
import LoadingSpinner from '../../../components/Common/Loader';
import { secondsToTime, serialize } from '../../../utils/utils';
import { formatCurrency } from '../../../utils/formats';
import GraphFilters from '../../../components/Common/GraphFilters';
import ApplyFilter from '../../../components/Common/ApplyFilter';
import { getUserProfile } from '../../../helpers/functions_helper';
import tasksService from "../../../services/tasks.service";
import { useNavigate } from 'react-router-dom';
//import  gfilters  from "../filter";
import { toast } from 'react-toastify';
import cpoService from '../../../services/cpo.service';
interface RevenueStreamProps extends CartProps {
    filters?: any;
}

const WebsiteUserBecomeCustomer: FC<RevenueStreamProps> = ({ hideHeading, filters = null }) => {

    const { t } = useTranslation();

    const userObj = getUserProfile('all-cpo');
    const navigate = useNavigate();
    const inititalFilter = {
        week: null,
        quarter: null,
        month: null,
        year: null,
        user_id: !(userObj.IS_PARTNER && userObj.IS_SUPER_ADMIN) ? userObj.USER_ID : null
    };

    const [loading, setLoading] = useState<boolean>(true);
    const [query, setQuery] = useState<string | null>(serialize(inititalFilter));
    const [filter, setFilter] = useState<any>(inititalFilter);
    const [selectedID, setSelectedID] = useState<any>({ id: null, event: null });

    useEffect(() => {
        setLoading(true);
     }, [localStorage.getItem("I18N_LANGUAGE")]);

    const viewTaskList = (i: any) => {
        if (data.ids) {
            const x = data.ids[i];
            setSelectedID({ id: null, event: null });
            if (x !== -1) {
                let _filter = {
                    type: 'fees',
                    id: x,
                    label: 'taskOriginated'
                }
                //gfilters.setFilter(_filter);
                navigate('../tasks/all-tasks');
            }
        }
    }

    useEffect(() => {
        if (selectedID?.event === 'click') {
            viewTaskList(selectedID.id);
        }
    }, [selectedID])

    const [data, setData] = useState<any>({
        series: [10, 20],
            options: {
              chart: {
                width: 380,
                type: 'pie'
              },
              labels: [t('Website User'), t('Client')],
              fill: {
                opacity: 1
              },
              stroke: {
                width: 1,
                colors: undefined
              },
              yaxis: {
                show: false
              },
              legend: {
                position: 'bottom'
              },
              plotOptions: {
                polarArea: {
                  rings: {
                    strokeWidth: 0
                  },
                  spokes: {
                    strokeWidth: 0
                  },
                }
              },
            },
    })

    const getChartData = async () => {
        try {
            const result = await cpoService.getWebsiteUserBecomeCustomer(query);
            console.log(result);
            if (result.data.status === 'success') {
                setData((data: any) => ({
                    ...data,
                    series: result?.data?.data,
                    options:{
                        ...data.options,
                        labels: [t('Website User'), t('Client')],
                    }
                }))
            }
            setLoading(false);
        } catch (error: any) {
            toast(error)
        }
    }

    const clearFilter = () => {
        setFilter(inititalFilter);
    }

    useEffect(() => {
        loading && getChartData();
    }, [loading])

    useEffect(() => {
        setQuery(serialize(filter));
        setLoading(true);
    }, [filter])

    useEffect(() => {
        filters && setFilter(filters)
    }, [filters])

    useEffect(() => {
        setLoading(true);
     }, [localStorage.getItem("I18N_LANGUAGE")]);

    return (
        <>
            <div className="d-sm-flex flex-wrap">
                <h4 className="card-title mb-4">{!hideHeading && t("Website user become customer")}</h4>
                <div className="ms-auto">
                    {/* <ApplyFilter filter={filter} /> */}
                    <GraphFilters
                        filter={filter}
                        setFilter={setFilter}
                        clearWorkAllocationFilter={clearFilter}
                        userObj={userObj}
                    />
                </div>
            </div>
            <div className="clearfix"></div>
            {loading ? <LoadingSpinner height={380} /> : <div style={{ height: '100%' }}><ReactApexChart options={data.options} series={data.series} type="pie" height={380} /></div>}
        </>
    )
}

export default WebsiteUserBecomeCustomer;